import { schemes, zSchema } from "@zeal/common";

export const createAppleWalletProvisionRequestSchema = zSchema.object({
  paycard_id: schemes.uuid(),
  certificates: zSchema.array(zSchema.string()),
  nonce: zSchema.string(),
  nonce_signature: zSchema.string(),
  app_version: zSchema.string(),
  companyID: schemes.companyID(),
});
export type TCreateAppleWalletProvisionRequest = zSchema.infer<
  typeof createAppleWalletProvisionRequestSchema
>;

export const createAppleWalletProvisionResponseSchema = zSchema.object({
  activation_data: zSchema.string(),
  card_id: zSchema.string(),
  encrypted_pass_data: zSchema.string(),
  ephemeral_public_key: zSchema.string(),
});
export type TCreateAppleWalletProvisionResponse = zSchema.infer<
  typeof createAppleWalletProvisionResponseSchema
>;
